import { Box, Typography, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";

import { financeApi } from "./apiService";
import { usePlanStatus } from "../../hooks/usePlanStatus";
import NavigationHeader from "../../components/NavigationHeader";
import PartySummaryCards from "./components/PartySummaryCards";
import { useToast } from "../../components/Toast";

const IncomeFinance = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [summaryData, setSummaryData] = useState<any>(null);
  const { planStatus } = usePlanStatus();
  const { showToast } = useToast();

  const getSummaryData = async () => {
    try {
      setIsLoading(true);
      const response = await financeApi.getIncomeSummary();
      setSummaryData(response);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      showToast();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (planStatus?.company?.id) {
      getSummaryData();
    } else {
      setIsLoading(false);
    }
  }, [planStatus]);

  if (isLoading) {
    return <Loading message="Loading financial data..." fullScreen={true} />;
  }

  return (
    <>
      <NavigationHeader
        title="Receivables"
        backNavigationEnabled={true}
        backNavigationTo="/finance"
        breadcrumbs={[
          { label: "Finance", path: "/finance" },
          { label: "Receivables" },
        ]}
      />

      {/* Income Summary Cards */}
      {summaryData ? (
        <PartySummaryCards
          summaryData={summaryData}
          loading={false}
          type="income"
        />
      ) : (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            px: 3,
            backgroundColor: "grey.50",
            borderRadius: 2,
            border: "2px dashed",
            borderColor: "grey.300",
          }}
        >
          <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
            No Summary Data Available
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Unable to load party summary data. Please try again later.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default IncomeFinance;
